export enum Event {
    IioSaidHello = 'IioSaidHello',
    UserReplied = 'UserReplied',
    ElementEdited = 'ElementEdited',
    ConfirmTest = 'ConfirmTest',
}
